import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "notification-avatar" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "notification-avatar__badge"
}
const _hoisted_4 = { class: "notification-content" }
const _hoisted_5 = { class: "notification-content__header" }
const _hoisted_6 = {
  key: 0,
  class: "notification-content__name"
}
const _hoisted_7 = {
  key: 1,
  class: "notification-content__time"
}
const _hoisted_8 = { class: "notification-content__message" }

import { useRouter } from 'vue-router'
import NotificationModel from '../../models/notification'
import { ROUTER_NAME } from '../../router'
import { notificationState } from '../../stores/notification'


export default /*@__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
    item: { default: null },
    mobile: { type: [Boolean, null], default: null }
  },
  emits: ["navigated"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const router = useRouter()

const formatRelativeTime = (dateInput: Date | string): string => {
  const date = new Date(dateInput)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)

  if (diffMins < 1) return 'たった今'
  if (diffMins < 60) return `${diffMins}分前`
  if (diffHours < 24) return `${diffHours}時間前`
  if (diffDays < 7) return `${diffDays}日前`
  
  return date.toLocaleDateString('ja-JP', { 
    month: 'short', 
    day: 'numeric' 
  })
}

const navigate = (promise: Promise<any>) => {
  emit('navigated')
  promise.catch((err) => {
    if (err?.name !== 'NavigationDuplicated' && err?.name !== 'NavigationFailure') {
      console.error(err)
    }
  })
}

const goDetailAction = () => {
  if (!props.item) return

  notificationState.markReaded({ id: props.item.id })

  switch(props.item.action) {
    case 'marked_exam':
      return navigate(router.push({
        name: 'exam-result',
        params: {
          examId: props.item.target.examId.toString(),
        },
        query: {
          user_exam_id: props.item.target.id.toString()
        }
      }))
    case 'comment':
      if (props.item.target.commentableType == 'Question') {
        return navigate(router.push({
          name: 'user-question-detail',
          params: {
            questionId: props.item.target.commentableId.toString()
          },
          hash: `#comment-${props.item.target.id}`
        }))
      }
      if (props.item.target.commentableType == 'Answer') {
        return navigate(router.push({
          name: 'user-question-detail',
          params: {
            questionId: props.item.target.questionId.toString()
          },
          hash: `#comment-${props.item.target.id}`
        }))
      }
      if (props.item.target.commentableType == 'Inquiry') {
        return navigate(router.push({
          name: ROUTER_NAME.INQUIRY_DETAIL,
          params: {
            inquiryId: props.item.target.commentableId.toString()
          }
        }))
      }
      if (props.item.target.commentableType == 'UserExam') {
        return navigate(router.push({
          name: ROUTER_NAME.EXAM_RESULT,
          params: {
            examId: props.item.target.examId.toString()
          },
          query: {
            user_exam_id: props.item.target.id.toString()
          },
          hash: `#comment-${props.item.target.id}`
        }))
      }
      break
    case 'ask':
      return navigate(router.push({
        name: 'user-question-detail',
        params: {
          questionId: props.item.target.id.toString()
        }
      }))
    case 'answer':
      return navigate(router.push({
        name: 'user-question-detail',
        params: {
          questionId: props.item.target.questionId.toString()
        },
        hash: `#answer-${props.item.target.id}`
      }))
    case 'information':
      return navigate(router.push({
        name: 'infor-detail',
        params: {
          inforId: props.item.targetId.toString()
        }
      }))
    case 'inquiry':
      return navigate(router.push({
        name: ROUTER_NAME.INQUIRY_DETAIL,
        params: {
          inquiryId: props.item.targetId.toString()
        }
      }))
    case 'teacher_approved_booking':
      emit('navigated')
      return location.href = '/classroom/appointment#/events/' + props.item.targetId.toString()
    case 'zoom_ready':
      emit('navigated')
      return location.href = '/classroom/appointment#/events/' + props.item.targetId.toString()
    case 'teacher_rejected_booking':
      emit('navigated')
      return location.href = '/classroom/appointment#/events/' + props.item.targetId.toString()
    case 'create_booking':
      emit('navigated')
      return location.href = props.item.url
    case 'course_purchase':
      emit('navigated')
      return location.href = props.item.url
    case 'certificate_approved':
      emit('navigated')
      return window.open(props.item.url || '/classroom/my-courses', '_blank')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    class: _normalizeClass(['notification-item', { 'notification-item--unread': __props.item.unread }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (goDetailAction()))
  }, {
    prepend: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_avatar, {
          size: "44",
          class: "notification-avatar__img"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: 
              __props.item.target && __props.item.target.user && __props.item.target.user.image
                ? __props.item.target.user.image.url
                : '/assets/user-958851872d7a849ea34d9887d31e41ce820428c6fccef8cb62b595382379b407.png'
            ,
              alt: "User avatar"
            }, null, 8 /* PROPS */, _hoisted_2)
          ]),
          _: 1 /* STABLE */
        }),
        (__props.item.unread)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (__props.item.target && __props.item.target.user)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.item.target.user.name), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (__props.item.createdAt)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(formatRelativeTime(__props.item.createdAt)), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(__props.item.message ? __props.item.message : _ctx.$t(`notification_action.${__props.item.action}`)), 1 /* TEXT */)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"]))
}
}

})